import { render, staticRenderFns } from "./AvatarList.vue?vue&type=template&id=70adb06d&scoped=true"
import script from "./AvatarList.vue?vue&type=script&lang=js"
export * from "./AvatarList.vue?vue&type=script&lang=js"
import style0 from "./AvatarList.vue?vue&type=style&index=0&id=70adb06d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70adb06d",
  null
  
)

export default component.exports